import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Container,
    Typography,
    Box,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Divider,
    Skeleton,
    Paper,
    Breadcrumbs,
    Link
} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { Link as RouterLink } from "react-router-dom";

const TurmobNews = () => {
    const [announcements, setAnnouncements] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchMevzuat = async () => {
            try {
                const originUrl = "https://www.turmob.org.tr/Mevzuat";
                const proxyUrl = `https://cors-proxy-suhas-projects-5922cb4f.vercel.app/?target=${encodeURIComponent(originUrl)}`;
                const response = await axios.get(proxyUrl, { headers: { "Content-Type": "text/html" } });

                const parser = new DOMParser();
                const doc = parser.parseFromString(response.data, "text/html");

                const mevzuatList = [];
                doc.querySelectorAll(".layout-container a").forEach((element) => {
                    const title = element.innerText.trim();
                    const baseUrl = element.href
                    const uri = new URL(baseUrl).pathname;
                    const url = `https://www.turmob.org.tr${uri}`;
                    mevzuatList.push({ title, url });
                });

                setAnnouncements(mevzuatList);
                setLoading(false);
            } catch (error) {
                console.error("Mevzuat duyuruları yüklenirken hata oluştu:", error);
                setLoading(false);
            }
        };

        fetchMevzuat();
    }, []);

    const renderAnnouncements = (list) => (
        <List>
            {list.map((item, index) => (
                <ListItem key={index} disableGutters sx={{ py: 1 }}>
                    <ListItemIcon>
                        <FiberManualRecordIcon sx={{ fontSize: 8, color: "#1976d2" }} />
                    </ListItemIcon>
                    <ListItemText>
                        <a href={item.url} target="_blank" rel="noopener noreferrer"
                           style={{ textDecoration: "none", color: "#333", fontSize: "16px", lineHeight: "1.5" }}>
                            {item.title}
                        </a>
                    </ListItemText>
                </ListItem>
            ))}
        </List>
    );

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
                <Link component={RouterLink} to="/" color="inherit">
                    Ana Sayfa
                </Link>
                <Typography color="text.primary">TÜRMOB Mevzuat Duyuruları</Typography>
            </Breadcrumbs>
            
            <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
                <Box display="flex" alignItems="center" mb={2}>
                    <img src="/turmob-logo.png" alt="TÜRMOB Logo" width={40} height={40} />
                    <Typography variant="h5" color="primary" fontWeight="bold" ml={2}>
                        TÜRMOB Mevzuat Duyuruları
                    </Typography>
                </Box>
                
                <Divider sx={{ mb: 3 }} />
                
                {loading ? (
                    <Box>
                        {[...Array(10)].map((_, index) => (
                            <Skeleton key={index} variant="text" height={40} sx={{ my: 1 }} />
                        ))}
                    </Box>
                ) : (
                    <Box>
                        {renderAnnouncements(announcements)}
                    </Box>
                )}
            </Paper>
        </Container>
    );
};

export default TurmobNews;